/**
 * RISK-WIZARD-OVERVIEW
 * Rappelle le risque concerne dans le wizard d'une mesure de prevention : image de sa famille,
 * libelle, nom du risque. Un simple bloc, pas une carte.
 */
import { getRiskFamilyImageUrl, RISK_FAMILY_IMAGE_STYLE } from "@/entities/risk-family/model/risk-family.utils"
import { faQuestion } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { PhysicalRisk } from "../model/physical-risk.types"

interface Props {
  isWithoutMargin?: boolean //Dans un entete, l'espacement vient deja du conteneur
  onClick?: () => void
  risk: PhysicalRisk
}

export default function RiskWizardOverview({ isWithoutMargin, onClick, risk }: Props) {
  //Une famille peut exister sans image (famille « Non défini », ou code absent) : on garde alors le glyphe
  const imageUrl = risk.cFamily ? getRiskFamilyImageUrl(risk.cFamily) : null

  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`${onClick ? "_hover" : ""} flex items-center gap-[14px] ${isWithoutMargin ? "" : "mb-20"}`}
      onClick={onClick}
      onKeyDown={
        onClick
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault()
                onClick()
              }
            }
          : undefined
      }>
      <div className="flex h-[44px] w-[44px] shrink-0 items-center justify-center">
        {imageUrl ? (
          <img
            alt={risk.cFamily?.name ?? ""}
            src={imageUrl}
            style={RISK_FAMILY_IMAGE_STYLE}
            onError={(e) => (e.currentTarget.style.display = "none")}
          />
        ) : (
          <FontAwesomeIcon className="grey-t text-[28px]" icon={faQuestion} />
        )}
      </div>
      <div className="min-w-0">
        <div className="grey-t text-base">Risque concerné</div>
        <div className="text-base leading-tight">{risk.cName}</div>
      </div>
    </div>
  )
}
